{ getKey, Key } = require '@trello/keybindings'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/list_copy'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ListCopyView extends View
  viewTitleKey: 'copy list'

  tagName: 'form'

  events:
    'click .js-submit': 'submit'
    'submit': 'submit'
    'keydown textarea[name="name"]': 'keydownEvent'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'copyListInlineDialog',
        containers:
          list:
            id: @model?.id || ''
          board:
            id: @model?.getBoard()?.id || ''
          organization:
            id: @model?.getBoard()?.getOrganization()?.id || ''

    @listenTo @model.getBoard(), 'change:limits', @render

  render: ->
    board = @model.getBoard()
    @$el.html template({
      canCopyTotal: !board.isOverLimit('lists', 'totalPerBoard')
      canCopyOpen: !board.isOverLimit('lists', 'openPerBoard')
      name: @model.get('name')
    })

    @

  keydownEvent: (e) ->
    if getKey(e) == Key.Enter
      Util.stop(e)
      @submit(e)
      return

  submit: (e) ->
    Util.stop(e)
    nameInput = @$('textarea[name="name"]')

    # return if the user hasn't entered a title
    if nameInput.val().trim() == ''
      nameInput.focus().select()
      return

    board = @model.getBoard()
    isOverLimit = board.isOverLimit('lists', 'totalPerBoard') ||
    board.isOverLimit('lists', 'openPerBoard')
    @$('.js-limit-exceeded').toggleClass('hide', !isOverLimit)
    if isOverLimit
      return


    if @model.cardList.length > 0
      hasAttachments = hasChecklists = false
      @model.cardList.forEach (card) ->
        hasAttachments = hasAttachments || card.attachmentList.length > 0
        hasChecklists = hasChecklists || card.checklistList.length > 0

      options = {
        $elem: @$(e.target),
        hasChecklists: hasChecklists,
        hasAttachments: hasAttachments,
        destinationBoard: board,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return

    listPos = board.listList.calcPos(@model.getIndexInList() + 1, @model, true)
    newListParams =
      idListSource: @model.id
      idBoard: @model.get('idBoard')
      pos: listPos
      name: nameInput.val().trim()
      closed: false

    newList = board.listList.create newListParams,
      error: =>
        board.listList.remove(newList)
    PopOver.hide()
    track("List", "Copy List")


    if @sendGASEvent
      Analytics.sendTrackEvent
        action: 'copied',
        actionSubject: 'list'
        source: 'copyListInlineDialog'
        attributes:
          listSourceId: @model?.id || ''
        containers:
          list:
            id: newList?.id || ''
          board:
            id: @model?.getBoard()?.id || ''
          organization:
            id: @model?.getBoard()?.getOrganization()?.id || ''

    return
